import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import './index.css'
import App from './App.jsx'
import { msalConfig } from './auth/msalConfig.js'
import { installGlobalHandlers } from './lib/logger.js'
import './lib/serverSync.js'
import './lib/logSync.js'

installGlobalHandlers()

// Dev-only: errors ook naar client/logs/ wegschrijven (STAP 4).
if (import.meta.env.DEV) {
  import('./lib/devLogSink.js')
    .then((m) => m.installDevLogSink())
    .catch(() => { /* stil — anti-lus */ })
}

// MSAL: één PublicClientApplication voor de hele app (Authorization Code + PKCE).
const msalInstance = new PublicClientApplication(msalConfig)

// Actief account bijhouden na een redirect-login (officiële msal-react aanpak).
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account)
  }
})

// msal-browser v5 vereist initialize() vóór gebruik; pas daarna renderen.
msalInstance.initialize().then(() => {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
  }

  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  )
})
